module.exports = __webpack_public_path__ + "static/img/3.3505873.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/quienes-somos-en/3.jpg
// module id = n5hO
// module chunks = 0